import { render, staticRenderFns } from "./LoopsHeader.vue?vue&type=template&id=8ddf6c68&scoped=true&"
import script from "./LoopsHeader.vue?vue&type=script&lang=js&"
export * from "./LoopsHeader.vue?vue&type=script&lang=js&"
import style0 from "./LoopsHeader.vue?vue&type=style&index=0&id=8ddf6c68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddf6c68",
  null
  
)

export default component.exports